export default __webpack_public_path__ + "static/media/Vijayavani2.f1fe33b4.png";